// @flow
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Page from '@atlaskit/page';
import Tabs, { Tab, TabList, TabPanel } from '@atlaskit/tabs';
import { gridSize } from '@atlaskit/theme';
import OctoPageSettings from './OctoPageSettings';
import ComponentLabels from './ComponentLabels';

const Container = styled.div`
    color: #172b4d;
    margin: 0;
    padding: 0;
    height: 100vh;
`;

const TabsWrapper = styled.div`
    width: 100%;
`;

const TabContentWrapper = styled.div`
    margin-top: ${2 * gridSize()}px;
    width: 100%;
`;

const ProjectSettings = () => {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    useEffect(() => {
        window.PlatformAdapter.resizeWindow('100%', '800px');
    }, []);

    return (
        <Container>
            <Page>
                <TabsWrapper>
                    <Tabs selected={selectedTabIndex} onChange={setSelectedTabIndex} id="project-settings-tabs">
                        <TabList>
                            <Tab>General</Tab>
                            <Tab>Import Components</Tab>
                        </TabList>
                        <TabPanel>
                            <TabContentWrapper>
                                <OctoPageSettings hideHeader fullWidth />
                            </TabContentWrapper>
                        </TabPanel>
                        <TabPanel>
                            <TabContentWrapper>
                                <ComponentLabels />
                            </TabContentWrapper>
                        </TabPanel>
                    </Tabs>
                </TabsWrapper>
            </Page>
        </Container>
    );
};

export default ProjectSettings;
